// hooks/useMemberRegistration.js

import { useState } from "react";
import { citiesList, getDistrictsForCity } from "../components/citiesData";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function useMemberRegistration() {
  const [cities] = useState(citiesList);
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateDistricts = (cityName) => {
    const districtsForCity = getDistrictsForCity(cityName);
    setDistricts(districtsForCity);
  };

  const registerMember = async (formData) => {
    setLoading(true);
    setError(null);

    try {
      // استخراج projectId و referralCode من الـURL في لحظة التسجيل
      const params = new URLSearchParams(window.location.search);
      const projectId = params.get("projectId");
      const referralCode = params.get("ref");

      const bodyObj = {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        role: "member",
        phoneNumber: formData.mobile,
        city: formData.city,
        district: formData.district,
      };
      if (projectId) {
        bodyObj.projectId = projectId;
      }
      if (referralCode) {
        bodyObj.referralCode = referralCode;
      }

      const res = await fetch(`${API_BASE_URL}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyObj),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "فشل التسجيل");

      return data;
    } catch (err) {
      setError(err.message || "فشل التسجيل. يرجى المحاولة مرة أخرى.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    cities,
    districts,
    loading,
    error,
    updateDistricts,
    registerMember,
  };
}

export default useMemberRegistration;